<template>
  <div class="fullPassport">
    <button class="goBack" @click="goBack()">
      <i class="fas fa-chevron-left"></i>
      {{ $t("authorization.back") }}
    </button>
    <form @submit.prevent="finalMessage">
      <div class="content">
        <div class="explanation">
          <h1>
            {{ $t("authorization.humanPassportTitle") }}
          </h1>
          <p>{{ $t("authorization.explanation") }}</p>
        </div>
        <img :src="imageUrl ? imageUrl : defaultImage" alt="" />
      </div>
      <div class="getImage">
        <div class="imageContent">
          <h1>{{ $t("authorization.getImage") }}</h1>
          <h3>{{ $t("authorization.imageFormat") }}</h3>
        </div>
        <input
          @input="setImage()"
          ref="image"
          type="file"
          class="file"
          accept="image/png, image/jpeg"
        />/>
        <button class="fakeButton">
          {{ $t("authorization.selectImage") }}
        </button>
      </div>
      <button :disabled="!imageUrl" type="submit" class="overlayWay">
        {{ $t("authorization.continue") }}
      </button>
      <button class="mainPage">{{ $t("authorization.mainPage") }}</button>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
export default {
  /*  eslint-disable */
  setup(props, { emit }) {
    /* eslint-enable */
    const store = useStore();
    const image = ref();
    const imageUrl = ref();

    const setImage = () => {
      const file = image.value.files[0];
      imageUrl.value = URL.createObjectURL(file);
    };

    const finalMessage = () => {
      if (!imageUrl.value) {
        alert("please send your passport image");
        return;
      }

      store.commit("updateUserModel", {
        passport_with_person: image.value.files[0],
      });

      store.dispatch("signUp", {
        cb: () => {
          emit("submitForm");
        },
        err: () => {},
      });
    };

    const goBack = () => {
      emit("goBack");
    };

    return {
      defaultImage: require("@/assets/passport.png"),
      image,
      imageUrl,
      setImage,
      goBack,
      finalMessage,
    };
  },
};
</script>

<style lang="scss" scoped>
.fullPassport {
  width: 100%;
  .goBack {
    color: var(--explanation-color);
    background: transparent;
    font-size: 1.1em;
    line-height: 1.2em;
    margin-left: 2rem;
    margin-top: 1rem;
    cursor: pointer;
  }
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .content {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 3rem;
      .explanation {
        width: 17rem;
        h1 {
          color: var(--title-color);
          font-size: 1.2em;
          line-height: 1.2em;
          font-weight: 400;
        }
        p {
          color: var(--content-opacity);
          font-size: 0.8em;
          line-height: 1em;
          font-weight: 400;
          margin-top: 0.625rem;
        }
      }
      img {
        width: 18rem;
        height: 12rem;
        border: 3px solid var(--explanation-color);
      }
    }
    .getImage {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 4.7rem;
      margin-bottom: 2rem;
      margin-top: 1.3rem;
      .imageContent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px dashed var(--explanation-color);
        padding: 1.1rem 3rem 1.1rem 3rem;
        h1 {
          color: var(--title-opacity-color);
          font-size: 1.2em;
          line-height: 1.2em;
          font-weight: 400;
        }
        h3 {
          color: var(--title-light);
          font-size: 0.8em;
          line-height: 1em;
          font-weight: 400;
        }
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
        opacity: 0;
      }
      .fakeButton {
        width: 9rem;
        height: 4.5rem;
        background: var(--explanation-color);
        color: var(--light);
        outline: none;
        margin-left: -1.4rem;
      }
    }
    .overlayWay {
      width: 21rem;
      height: 3.6rem;
      border: 2px solid rgba(108, 143, 186, 1);
      color: rgba(108, 143, 186, 1);
      margin-left: auto;
      margin-right: auto;
      background: transparent;
      outline: none;
      cursor: pointer;
      &:disabled{
        opacity: 0.5;
        pointer-events: none;
      }
    }

    .mainPage {
      grid-area: mainPage;
      font-size: 1.2em;
      line-height: 1.2em;
      background: transparent;
      color: var(--back-btn);
      border-bottom: 1px solid rgba(128, 128, 128, 1);
      margin-bottom: 1.4rem;
      margin-top: 1rem;
      width: max-content;
      margin-left: auto;
      margin-right: auto;
      cursor: pointer;
    }

  }
}

@media screen and (max-width: 1366px) {
  .fullPassport {
    width: 100%;
    form {
      .content {
        .explanation {
          margin-right: 0.938rem;
        }
        img {
          width: 14rem;
          height: 9.4rem;
        }
      }
      .getImage {
        display: flex;
        flex-direction: column-reverse;
        .imageContent {
          border: none;
          padding: 0;
          h3 {
            margin-right: 1rem;
          }
        }
        h1 {
          display: none;
        }
        .file {
          height: max-content;
        }
        .fakeButton {
          height: 3rem;
        }
      }
    }
  }
}
@media screen and (max-width: 540px) {
  .fullPassport {
    form {
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .explanation {
          width: 100%;
          text-align: center;
        }
        img {
          width: 14rem;
          height: 9.4rem;
          margin-top: 0.313rem;
        }
      }
      .getImage {
        display: flex;
        flex-direction: column-reverse;
        height: 100%;
        margin-top: 0.938rem;
        margin-bottom: 0.938rem;
        .imageContent {
          border: none;
          padding: 0;
          h3 {
            margin-right: 1rem;
          }
        }
        h1 {
          display: none;
        }
        .file {
          height: max-content;
        }
        .fakeButton {
          height: 3rem;
        }
      }
      .overlayWay {
        width: 16rem;
        height: 3.3rem;
      }
    }
  }
}
</style>
